import { Directive } from 'vue'

export const elemHeight: Directive = (el, binding) => {
  if (binding.value) {
    el.style.height = binding.value
  }
}
